import { render, staticRenderFns } from "./test-detail.vue?vue&type=template&id=15abf135&scoped=true&"
import script from "./test-detail.vue?vue&type=script&lang=js&"
export * from "./test-detail.vue?vue&type=script&lang=js&"
import style0 from "./test-detail.vue?vue&type=style&index=0&id=15abf135&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15abf135",
  null
  
)

export default component.exports